import { cityValidation, stringValidation, zipValidation } from 'src/services/validation';
import * as Yup from 'yup';

// The order of these is important due to the validation running sequentially.
// Whatever order these are in is the order that the input focusing will occur in if there is an erorr.
const propertyInformationSchema = (type) =>
  Yup.object().shape({
    info: Yup.object().shape({
      accountNo: ['personal', 'greenbelt'].includes(type) ? stringValidation() : Yup.string(),
      serialNumber: type === 'real' ? stringValidation() : Yup.string(),
      type: Yup.string(),
      vin: type === 'vehicle' ? stringValidation() : Yup.string(),
      address: Yup.object().shape({
        street: Yup.string(),
        city: cityValidation({ required: false }),
        state: Yup.string(),
        zip: zipValidation({ required: false }),
      }),
    }),
  });

export default propertyInformationSchema;
